import { Link } from "react-router-dom";
import { Heart, LogOut, UserRound } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export function UserMenu({ compact = false }) {
  const { user, shortlist, setAuthOpen, logout } = useAuth();

  if (!user) {
    return (
      <button
        data-testid={compact ? "mobile-nav-signin-btn" : "nav-signin-btn"}
        onClick={() => setAuthOpen(true)}
        className={`flex items-center gap-2 whitespace-nowrap uppercase tracking-[0.2em] text-[#A1A1AA] hover:text-[#F3E5AB] transition-colors ${compact ? "text-sm" : "text-[11px]"}`}
      >
        <UserRound size={compact ? 16 : 15} className="text-[#D4AF37]" /> Sign In
      </button>
    );
  }

  return (
    <div className={`flex items-center ${compact ? "gap-5" : "gap-3"}`} data-testid={compact ? "mobile-user-menu" : "nav-user-menu"}>
      <Link
        to="/shortlist"
        data-testid={compact ? "mobile-nav-shortlist-link" : "nav-shortlist-link"}
        className="relative flex items-center gap-2 text-[#A1A1AA] hover:text-[#F3E5AB] transition-colors"
        aria-label="My shortlist"
      >
        <Heart size={16} className="text-[#D4AF37]" />
        {compact && <span className="text-sm uppercase tracking-[0.2em]">My Shortlist</span>}
        <span data-testid="nav-shortlist-count" className={`grid place-items-center min-w-[18px] h-[18px] px-1 rounded-full bg-[#D4AF37] text-black text-[10px] font-bold ${compact ? "" : "absolute -top-2 -right-3"}`}>
          {shortlist.length}
        </span>
      </Link>
      {!compact && (
        <span className="hidden 2xl:inline text-[11px] tracking-wider text-[#A1A1AA] max-w-[120px] truncate" data-testid="nav-user-name">{user.name.split(" ")[0]}</span>
      )}
      <button data-testid={compact ? "mobile-nav-logout-btn" : "nav-logout-btn"} onClick={logout} aria-label="Sign out" className={`flex items-center gap-2 text-[#71717A] hover:text-[#F3E5AB] transition-colors ${compact ? "text-sm uppercase tracking-[0.2em]" : ""}`}>
        <LogOut size={15} />{compact && "Sign Out"}
      </button>
    </div>
  );
}
